// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"fe84d711","94":"2fcfd83f","234":"6fdd290a","706":"bef88a40","759":"b3c6f0ae"}[chunkId] + ".chunk.js";
};